module.exports = __webpack_public_path__ + "img/yeremi-espinoza.481ec8bc.png";